import { Icon, Header as SegmentHeader, Segment, Container, Message } from "semantic-ui-react"
import Footer from "../../common/Footer"
import { IShareListComponentProps } from "../../interfaces/shares/IShareListComponentProps"
import Header from "../../common/Header"
import { MenuBar } from "../../shell/MenuBar"

/**
 * Screen displayed when the Smartsheet consent collection period has ended.
 */
const FinishedScreen = ({ sso, account, instance }: IShareListComponentProps) => {

    // Empty handlers for the header and footer components
    const onFilterTextChanged = () => {
        // No-op - search is disabled on this screen
    }

    const handleSubmitConsent = () => {
        // No-op - consent submission is disabled
    }

    return <div className='Shell'>
        <div className='Menubar'>
            <MenuBar username={account?.name} roles={account?.idTokenClaims?.roles} instance={instance} />
        </div>
        <Container className='ContentArea' style={{ marginTop: '24px' }}>
            {
                sso === undefined
                    ?
                    <Segment>
                        Valid authentication token was not found. Please refresh the page and log in.
                    </Segment>
                    :
                    <>
                        <div style={{ 
                            background: "#fff", 
                            paddingTop: "42px", 
                            paddingBottom: "42px", 
                            marginBottom: "24px",
                            textAlign: 'center'
                        }}>
                            <div style={{ color: '#888', fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
                                <h2 style={{ color: '#00605E', marginBottom: '24px' }}>
                                    Smartsheet Migration Consent Collection Period Has Concluded
                                </h2>
                                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                                    The designated timeframe for collecting user consent regarding Smartsheet data migration 
                                    preferences has officially concluded as of the established deadline.
                                </p>
                            </div>
                        </div>

                        <Segment placeholder basic style={{ padding: '48px' }}>
                            <SegmentHeader icon>
                                <Icon name='calendar times outline' size='huge' style={{ color: '#00605E' }} />
                                <div style={{ marginTop: '24px' }}>
                                    <h3 style={{ color: '#333', marginBottom: '16px' }}>
                                        Collection Period Status: Closed
                                    </h3>
                                    <div style={{ 
                                        fontSize: '16px', 
                                        color: '#666', 
                                        lineHeight: '1.7',
                                        maxWidth: '600px',
                                        margin: '0 auto',
                                        textAlign: 'left'
                                    }}>
                                        <p style={{ marginBottom: '16px' }}>
                                            <strong>Thank you for your participation.</strong> All user preferences and migration 
                                            decisions have been successfully recorded and processed according to our established 
                                            data governance protocols.
                                        </p>
                                    </div>
                                </div>
                            </SegmentHeader>
                        </Segment>
                    </>
            }
        </Container>
    </div>

}

export default FinishedScreen
